export default "__VITE_ASSET__Cc1t2LSe__"